import Wishlistshare from "./Wishlistshare.vue";

export default {

    wishlistshare: Wishlistshare,

}